import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../mensajes2";
import { Dimmer } from "../spinner";
import axios from "axios";
import { validaMonto, formatMoneda } from "../../util/varios";
import { Input, Textarea } from "../../ui/inputs/Input";
import { DangerButton, SuccessButton } from "../../ui/buttons/Button";

const ModalTipologia = (props) => {
  let op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const txtcodtipoligia = useRef();
  const txtDescrip = useRef();
  const txtValorTipo = useRef();
  const btnCancela = useRef();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [values, setValues] = useState({
    idtipologia: "",
    codtipologia: "",
    descripcion: "",
    valortipo: "",
  });
  const [activate, setActivate] = useState(false);
  const [operacion, setOperacion] = useState("0");
  const blanquear = () => {
    setValues({
      idtipologia: "",
      codtipologia: "",
      descripcion: "",
      valortipo: "",
    });
  };
  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideCancela();
  };
  const cancelar = () => {
    props.onHideCancela();
    blanquear();
  };
  const onChange = (e) => {
    e.preventDefault();
    if (e.target.type === "text" || e.target.type === "textarea") {
      e.target.value = e.target.value;
      setValues({ ...values, [e.target.name]: e.target.value });
    } else {
      setValues({ ...values, [e.target.name]: e.target.value });
    }
  };

  const procesarDetalles = () => {
    let endpoint = `${op.conexion}/api/inmueble/actualizartipologia`;
    let body;
    setActivate(true);
    body = {
      operacion: operacion,
      nid: operacion === 1 ? 0 : values.idtipologia,
      cod: txtcodtipoligia.current.value.toUpperCase(),
      descr: txtDescrip.current.value.toUpperCase(),
      val: txtValorTipo.current.value.replace(/\./g, "").replace(",", "."),
    };
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Registro Registrada Exitosamente",
              icono: "exito",
            });
          } else if (operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Registro Modificada Exitosamente",
              icono: "exito",
            });
          } else if (operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Registro Eliminada Exitosamente",
              icono: "exito",
            });
          }
          props.onHideRender();
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };
  const onChangeValidar = (e) => {
    e.preventDefault();
    let sigue = true;
    if (txtcodtipoligia.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar el código de la tipologia",
        icono: "informacion",
      });
      sigue = false;
      txtcodtipoligia.current.focus();
    } else if (txtDescrip.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar la descripción de la tipologia",
        icono: "informacion",
      });
      sigue = false;
      txtDescrip.current.focus();
    } else if (txtValorTipo.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar el valor de la tipologia",
        icono: "informacion",
      });
      sigue = false;
      txtValorTipo.current.focus();
    }
    if (sigue) {
      procesarDetalles();
    }
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (
      event.target.value === "" ||
      parseFloat(
        event.target.value.trim().replace(/\./g, "").replace(",", ".")
      ) === 0.0
    ) {
      event.target.value = "0,00";
    }
    if (event.which >= 37 && event.which <= 40) {
      event.preventDefault();
    }
    let e = event.target.value
      .replace(/\D/g, "")
      .replace(/([0-9])([0-9]{2})$/, "$1.$2")
      .replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ",");
    return formatMoneda(e);
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.521)",
      }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        if (props.operacion !== 1) {
          setValues(props.tipologia);
        }
      }}
    >
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between text-light azulGradiant rounded-top">
        <h3 className="fw-bold m-0">
          {operacion === 1
            ? "Agregar Valor Tipologia"
            : operacion === 2
            ? "Editar Valor Tipologia"
            : operacion === 3
            ? "Eliminar Valor Tipologia"
            : "Consultar Valor Tipologia"}{" "}
        </h3>
        <a
          type="button"
          ref={btnCancela}
          className="text-light fw-bold fs-6"
          onClick={cancelar}
        >
          Salir <i className="fas fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body className="col-12 m-0 p-2 d-flex flex-wrap">
          <div className="col-3 m-0 mb-2 p-0">
            <Input label = 'Código'
              disabled
              name="idtipologia"
              value={values.idtipologia != "" ? values.idtipologia.trim() : ""}
              onChange={onChange}
            />
          </div>
          <div className="col-6 m-0 mb-2 ml-auto p-0">
            <Input label = 'Código de la Tipologia:'
              disabled={operacion === 1 || operacion === 2 ? false : true}
              name="codtipologia"
              ref={txtcodtipoligia}
              value={values.codtipologia != "" ? values.codtipologia : ""}
              onChange={onChange}
            />
          </div>
          <div className="col-12 m-0 mb-2 p-0">
            <Textarea label = 'Descripción'
              style={{ height: 70 }}
              disabled={operacion === 1 || operacion === 2 ? false : true}
              ref={txtDescrip}
              name="descripcion"
              value={values.descripcion != "" ? values.descripcion : ""}
              onChange={onChange}
            />
          </div>
          <div className="col-6 m-0 ml-auto p-0 d-flex">
            <Input label = 'Valor Tipología:'
              ref={txtValorTipo}
              disabled={operacion === 1 || operacion === 2 ? false : true}
              onKeyUp={handleInputMontoChange}
              onBlur={handleInputMontoChange}
              name="valortipo"
              defaultValue={
                values.valortipo
                  ? values.valortipo != ""
                    ? formatMoneda(
                        values.valortipo.toString().replace(".", ","),
                        ",",
                        ".",
                        2
                      )
                    : ""
                  : ""
              }
              onChange={onChange}
            />
            <span className="input-group-text" id="inputGroup-sizing-sm">
              (1000%/m2)
            </span>
          </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          onClick={onChangeValidar}
        >
            Aceptar
        </SuccessButton>
        <DangerButton
          ref={btnCancela}
          onClick={cancelar}
        >
            Cancelar
        </DangerButton>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <Dimmer active={activate} inverted></Dimmer>
    </Modal>
  );
};

export default ModalTipologia;
